import React, { useState } from 'react'
import { Pencil } from 'react-bootstrap-icons'
import Edit from './edit'
import isStudent from '../../../utilities/is-student'

const UserNameField = ({
    user={},
    canEdit,
}) => {
    const [ isEditing, setEditing ] = useState(false)

    if (!isStudent(user)) {
        return null
    }

    if (isEditing) {
        return (<Edit user={user} onClose={() => setEditing(false)} />)
    }

    const renderEditButton = () => {
        if (!canEdit) {
            return null
        }

        return (
            <div style={{ cursor: 'pointer' }} onClick={() => setEditing(true)} ><Pencil /></div>
        )
    }

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        }}>
            ID: {user.studentId || 'N/A'}
            {renderEditButton()}
        </div>
    )
}

export default UserNameField